import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatOption } from '@angular/material/core';
import { firstValueFrom, map, Observable, startWith } from 'rxjs';
import { MessageDialogComponent } from '../quotation-dialog/message-dialog/message-dialog.component';
import { Destination } from '../../shared/models/quotation-model/catalogs/destination.model';
import { Brand } from '../../shared/models/quotation-model/catalogs/brand.model';
import { Model } from '../../shared/models/quotation-model/catalogs/quotation-model.model';
import { PlanType } from '../../shared/models/quotation-model/catalogs/plan-type.model';
import { EditByModel } from '../../shared/models/quotation-model/main/edit-by-model-quotation.model';
import { OtherModelQuotation } from '../../shared/models/quotation-model/main/other-model';
import { BrandService } from '../../shared/services/quotation/catalogs/brand.service';
import { DestinationService } from '../../shared/services/quotation/catalogs/destination.service';
import { ModelService } from '../../shared/services/quotation/catalogs/model.service';
import { PlanTypeService } from '../../shared/services/quotation/catalogs/plan-type.service';
import { YearService } from '../../shared/services/quotation/catalogs/year.service';
import { QuotationService } from '../../shared/services/quotation/quotation.service';
import { EventEmiterService } from '../../shared/services/quotation/event-emiter.service';
import { MatFormField, MatError, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { QuotationFinancialValues } from '../../shared/models/quotation-model/main/quotation-financial-values.model';

@Component({
  selector: 'app-asset-section',
  templateUrl: './asset-section.component.html',
  styleUrls: ['./asset-section.component.scss'],
  imports: [
    MatFormField,
    MatSelect,
    MatOption,
    MatError,
    MatLabel,
    MatInputModule,
    TranslateModule,
    ReactiveFormsModule,
  ],
})
export class AssetSectionComponent implements OnInit {
  @Input() quotationId: any;
  @Input() ticketId!: number;

  @Output() assetReturn = new EventEmitter<{
    selectedDestination: Destination;
    selectedBrand: Brand;
    modelSelected: Model;
    otherBrand: string;
    otherType: string;
    otherModel: string;
    planTypes: PlanType[];
  }>();

  hasQuotation!: boolean;
  othersSelected: boolean = false;
  activeAsset: boolean = true;
  assetFormGroup!: FormGroup;
  otherAssetFormGroup!: FormGroup;

  selectedDestination = {} as Destination;
  destinations!: Destination[];

  brands!: Brand[];
  brandsFilteredOptions!: Brand[];
  selectedBrand = {} as Brand;
  brandDummy = {} as Brand;

  model = {} as Model;
  models!: Model[];
  modelsFilteredOptions!: Model[];
  selectedYear: string = '';
  years!: Model[];
  modelSelected = {} as Model;
  editByModel = {} as EditByModel;
  otherModel = {} as OtherModelQuotation;

  planTypes!: PlanType[];

  constructor(
    public dialog: MatDialog,
    private quotationService: QuotationService,
    private formBuilder: FormBuilder,
    private destinationService: DestinationService,
    private brandService: BrandService,
    private eventEmiterService: EventEmiterService,
    private modelService: ModelService,
    private yearService: YearService,
    private planTypeService: PlanTypeService,
    private translate: TranslateService,
    private loader: EventEmiterService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.loadDestinations();

    if (this.quotationId > 0) {
      this.hasQuotation = true;
    }

    this.assetFormGroup = this.formBuilder.group({
      assetType: ['', [Validators.required]],
      brand: ['', [Validators.required]],
      assetModel: ['', [Validators.required]],
      year: ['', Validators.required],
      otherBrand: [''],
      otherType: [''],
      otherModel: [''],
    });
  }

  validateOption(options: any, control: any) {
    const selectedOption = control.value;
    if (!selectedOption || !options.some((obj: any) => obj.id === selectedOption)) {
      return { invalidOption: true };
    }
    return null;
  }

  //se va a todos los componentes
  async loadQuotation() {
    var response = await firstValueFrom(
      this.quotationService.getQuotationFinancialValues(this.quotationId),
    );
    this.selectedBrand = { id: response.brandId, description: response.brandDescription } as Brand;
    //se usa en summary , asset
    this.selectedDestination = {
      id: response.destinationId,
      description: response.destinationDescription,
    } as Destination;
    //se usa en asset y financing
    this.modelSelected = { id: response.modelId, description: response.modelDescription } as Model;
    //assets
    //this.loadDestinations();
    this.destinations = await firstValueFrom(this.destinationService.getDestinations());
    //asset
    //this.loadPlanTypes(); Utilizamos la forma await para asegurar que se resuelva este servicio que trae datos antes de continuar
    this.planTypes = await firstValueFrom(this.planTypeService.getPlanTypes());
    //assets
    await this.loadBrands(response.destinationId);
    //assets
    await this.loadModels(response.brandId);

    await this.loadYears();

    if (this.modelSelected.description == 'OTROS') {
      this.othersSelected = true;
      this.assetFormGroup = this.formBuilder.group({
        assetType: ['', [Validators.required, this.validateOption.bind(this, this.destinations)]],
        brand: ['', [Validators.required, this.validateOption.bind(this, this.brands)]],
        year: [''],
        assetModel: ['', [Validators.required, this.validateOption.bind(this, this.models)]],
        otherBrand: [response.otherBrand, [Validators.required]],
        otherType: [response.otherType, [Validators.required]],
        otherModel: [response.otherModel, [Validators.required]],
      });
    } else {
      this.assetFormGroup = this.formBuilder.group({
        assetType: ['', [Validators.required, this.validateOption.bind(this, this.destinations)]],
        brand: ['', [Validators.required, this.validateOption.bind(this, this.brands)]],
        year: [''],
        assetModel: ['', [Validators.required, this.validateOption.bind(this, this.models)]],
        otherBrand: [''],
        otherType: [''],
        otherModel: [''],
      });
    }
    //todos? o assets
    this.loadAssetData(
      response.destinationId,
      response.brandId,
      response.modelId,
      response.yearModelDescription,
    );
  }

  loadAssetData(assetTypeObj: any, brandObj: any, assetModelObj: any, yearModel: any) {
    this.assetFormGroup.patchValue({
      assetType: assetTypeObj,
      brand: brandObj,
      year: yearModel,
      assetModel: assetModelObj,
    });
  }

  async loadDestinations() {
    this.destinations = await firstValueFrom(this.destinationService.getDestinations());
  }

  async loadBrands(destinationId: number) {
    this.brands = await firstValueFrom(this.brandService.getByDestinationId(destinationId));
    this.brandsFilteredOptions = this.brands;
  }

  filterBrand(name: string): void {
    const filterValue = name.toUpperCase();
    this.brandsFilteredOptions = this.brands.filter((option) =>
      option.description.toUpperCase().includes(filterValue),
    );
  }

  async loadModels(brandId: number, year: any = '') {
    this.models = await firstValueFrom(this.modelService.getModels(brandId, year));
    this.modelsFilteredOptions = this.models;
  }

  filterModel(name: string): void {
    const filterValue = name.toUpperCase();
    this.modelsFilteredOptions = this.models.filter((option) =>
      option.description.toUpperCase().includes(filterValue),
    );
  }

  async loadYears() {
    this.years = await firstValueFrom(this.yearService.getYears());
  }

  async loadPlanTypes() {
    this.planTypes = await firstValueFrom(this.planTypeService.getPlanTypes());
  }

  onSubmitAsset(auto: boolean = false) {
    if (!this.assetFormGroup.invalid) {
      if (this.othersSelected && !auto) {
        this.otherModel = {
          quotationId: this.quotationId,
          otherBrand: this.assetFormGroup?.get('otherBrand')?.value,
          otherType: this.assetFormGroup?.get('otherType')?.value,
          otherModel: this.assetFormGroup?.get('otherModel')?.value,
        };
        this.quotationService
          .createQuotationOtherModel(this.otherModel)
          .subscribe((response) => {});
      }
      this.sendAssetToParent();
      return true;
    } else {
      if (auto) {
        this.loader.isLoadingPage(false);
        this.assetFormGroup.markAllAsTouched();
        this.openDialogChangesWarning();
      }
      return false;
    }
  }

  openDialogChangesWarning() {
    const dialogRef = this.dialog.open(MessageDialogComponent, {
      width: '350px',
      data: this.translate.instant('quotation.fieldNames.changesDetected'),
      panelClass: 'dialog-container-custom',
    });
  }

  async onChangeAssetType(event: any) {
    const option = event.source.selected;
    this.selectedDestination = { id: option.value, description: option.viewValue } as Destination;
    this.brands = [];
    this.selectedBrand = {} as Brand;
    this.assetFormGroup?.get('brand')?.setValue('');
    this.loader.isLoadingPage(true);
    await this.loadBrands(this.selectedDestination.id);
    await this.loadYears();
    this.assetFormGroup
      .get('brand')!
      .setValidators([Validators.required, this.validateOption.bind(this, this.brands)]);
    this.loader.isLoadingPage(false);
  }

  async onChangeAssetModel(event: any) {
    const option = event.source.selected;
    this.modelSelected = { id: option.value, description: option.viewValue } as Model;
    this.othersSelected = this.modelSelected.description == 'OTROS';
    if (this.othersSelected) {
      this.assetFormGroup?.get('otherBrand')?.setValidators([Validators.required]);
      this.assetFormGroup?.get('otherType')?.setValidators([Validators.required]);
      this.assetFormGroup?.get('otherModel')?.setValidators([Validators.required]);
    } else {
      this.assetFormGroup?.get('otherBrand')?.setValidators([]);
      this.assetFormGroup?.get('otherType')?.setValidators([]);
      this.assetFormGroup?.get('otherModel')?.setValidators([]);
    }
    this.editByModel.quotationId = this.quotationId;
    this.editByModel.modelId = this.modelSelected.id;
    this.quotationService.updateQuotation(this.editByModel).subscribe((response) => {});
    await this.loadPlanTypes();
    this.onSubmitAsset();
  }

  async onChangeBrand(event: any) {
    const option = event.source.selected;
    this.selectedBrand = { id: option.value, description: option.viewValue } as Brand;
    await this.loadModels(this.selectedBrand.id, this.selectedYear);
    this.assetFormGroup
      ?.get('assetModel')
      ?.setValidators([Validators.required, this.validateOption.bind(this, this.models)]);
  }

  async onChangeYear(event: any) {
    if (this.selectedBrand != null) {
      const option = event.source.selected;
      this.selectedYear = option.viewValue;
      await this.loadModels(this.selectedBrand.id, this.selectedYear);
      this.assetFormGroup
        ?.get('assetModel')
        ?.setValidators([Validators.required, this.validateOption.bind(this, this.models)]);
    }
  }

  displayFn(brand: Brand): string {
    return brand && brand.description ? brand.description : '';
  }

  sendAssetToParent() {
    this.assetReturn.emit({
      selectedDestination: this.selectedDestination,
      selectedBrand: this.selectedBrand,
      modelSelected: this.modelSelected,
      otherBrand: this.assetFormGroup.get('otherBrand')!.value,
      otherType: this.assetFormGroup.get('otherType')!.value,
      otherModel: this.assetFormGroup.get('otherModel')!.value,
      planTypes: this.planTypes,
    });
  }
}
